import React from 'react'
import { FaWhatsapp, FaGithub, FaInstagram, FaLinkedin } from 'react-icons/fa'
import { SiGmail } from 'react-icons/si'
import { Link } from 'react-router-dom'

export default function Footer() {
    return (
        <div className='w-full min-h-[30vh] footer justify-center items-center'>
            <hr className='w-2/3 h-[2px] bg-cyan mx-auto mb-6 mt-8' />
            <h4 className='font-light mt-2 mb-4 text-center text-gray-400 text-[36px]'>Contact Me!</h4>
            
            <div className='flex flex-wrap justify-center items-center gap-12 z-10'>
                <div className='w-6 h-6 bg-success text-white text-[22px] flex justify-center items-center rounded-full'>
                    <Link to='https://wa.me/905442555993'>
                        <FaWhatsapp />
                    </Link>
                </div>
                <div className='w-6 h-6 bg-white text-black text-[1.5rem] flex justify-center items-center  rounded-full'>
                    <Link to='https://github.com/tunahantatli'>
                        <FaGithub />
                    </Link>
                </div>
                <div className='w-6 h-6 instagram-icon font-light text-[1.5rem] flex justify-center items-center  rounded-md'>
                    <Link to='https://www.instagram.com/tunahantatli/'>
                        <FaInstagram />
                    </Link>
                </div>
                <div className='w-6 h-6 bg-white text-primary text-[1.75rem] flex justify-center items-center  rounded-lg'>
                    <Link to='https://www.linkedin.com/in/tunahantatli/'>
                        <FaLinkedin />
                    </Link>
                </div>
                <div className='w-6 h-6 bg-white text-red-700 text-[1rem] flex justify-center items-center  rounded-2xl'>
                    <Link to='mailto:tunahantatl@gmail.com'>
                        <SiGmail />
                    </Link>
                </div>
            </div>
        </div>
    )
}
